import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/bindPage', component: () => import('@/views/login/bindPage'), hidden: true },
  { path: '/ispLogin', component: () => import('@/views/login/ispLogin'), hidden: true },
  { path: '/forget', component: () => import('@/views/login/forgetPwd'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '/settle', component: () => import('@/views/ssm/AddSupplier'), hidden: true },
  { path: '/select', component: () => import('@/views/ssm/selectType'), hidden: true },
  { path: '/service', component: () => import('@/views/isp/AddFacilitator'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),//这块准确定位的原因是Layout.vue下的app-main的route-view
      meta: { title: '首页', icon: 'home' }
    }]
  }
]

export const asyncRouterMap = [
  // 商品模块
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: { title: '商品管理', icon: 'product' },
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: { title: '在售商品', icon: 'product-list' }
    }, {
      path: 'sellOutProduct',
      name: 'sellOutProduct',
      component: () => import('@/views/pms/productSellOut/index'),
      meta: { title: '售罄商品', icon: 'product-list' }
    }, {
      path: 'soldOutProduct',
      name: 'soldOutProduct',
      component: () => import('@/views/pms/productSoldOut/index'),
      meta: { title: '下架商品', icon: 'product-list' }
    }, {
      path: 'lowStockProduct',
      name: 'lowStockProduct',
      component: () => import('@/views/pms/productLowStock/index'),
      meta: { title: '库存预警', icon: 'product-list' }
    }, {
      path: 'recycledProduct',
      name: 'recycledProduct',
      component: () => import('@/views/pms/productRecycled/index'),
      meta: { title: '回收站', icon: 'product-recycle' }
    }, {
      path: 'productAudit',
      name: 'productAudit',
      component: () => import('@/views/pms/productAudit/index'),
      meta: { title: '待审核仓库', icon: 'product-list' }
    }, {
      path: 'auditBack',
      name: 'auditBack',
      component: () => import('@/views/pms/productAudit/auditBack'),
      meta: { title: '商品驳回', icon: 'product-list' }
    },
    {
      path: 'productTempdb',
      name: 'productTempdb',
      component: () => import('@/views/pms/productTempdb/index'),
      meta: { title: '商品临时库', icon: 'product-list' }
    }, {
      path: 'addProduct',
      name: 'addProduct',
      component: () => import('@/views/pms/product/add'),
      meta: { title: '添加商品', icon: 'product-add' }
    }, {
      path: 'importProduct',
      name: 'importProduct',
      component: () => import('@/views/pms/productImport/index'),
      meta: { title: '商品导入', icon: 'product-add' }
    }, {
      path: 'updateProduct',
      name: 'updateProduct',
      component: () => import('@/views/pms/product/update'),
      meta: { title: '修改商品', icon: 'product-add' },
      hidden: true
    }, {
      path: 'batchAddProduct',
      name: 'batchAddProduct',
      component: () => import('@/views/pms/batchAddProduct/index'),
      meta: { title: '商品导入', icon: 'product-add' },
      hidden: true
    }]
  },
  // 商品数据
  {
    path: '/pmd',
    component: Layout,
    redirect: '/pmd/photoGallery',
    name: 'pmd',
    meta: { title: '商品数据', icon: 'product' },
    children: [{
      path: 'photoGallery',
      name: 'photoGallery',
      component: () => import('@/views/pms/photoGallery/index'),
      meta: { title: '图片库管理', icon: 'tree' },
    }, {
      path: 'addPhoto',
      name: 'addPhoto',
      component: () => import('@/views/pms/photoGallery/addPhoto'),
      meta: { title: '添加相册', icon: 'product-recycle' },
      hidden: true
    }, {
      path: 'updatePhoto',
      name: 'updatePhoto',
      component: () => import('@/views/pms/photoGallery/addPhoto'),
      meta: { title: '编辑相册', icon: 'product-recycle' },
      hidden: true
    }, {
      path: 'viewPhoto',
      name: 'viewPhoto',
      component: () => import('@/views/pms/photoGallery/viewPhoto'),
      meta: { title: '查看相册', icon: 'product-recycle' },
      hidden: true
    }, {
      path: 'productComment',
      name: 'productComment',
      component: () => import('@/views/pms/productComment/index'),
      meta: { title: '评价管理', icon: 'product-comment' }
    }, {
      path: 'replyComment',
      name: 'replyComment',
      component: () => import('@/views/pms/productComment/reply'),
      meta: { title: '回复评论', icon: 'product-comment' },
      hidden: true
    }, {
      path: 'beDownloaded',
      name: 'beDownloaded',
      component: () => import('@/views/pms/productDataManagement/beDownloaded'),
      meta: { title: '下载商品', icon: 'product-list' }
    }, {
      path: 'pageView',
      name: 'pageView',
      component: () => import('@/views/pms/productDataManagement/pageView'),
      meta: { title: '商品浏览量', icon: 'product-list' }
    }, {
      path: 'salesVolume',
      name: 'salesVolume',
      component: () => import('@/views/pms/productDataManagement/salesVolume'),
      meta: { title: '商品销售量', icon: 'product-list' }
    }, {
      path: 'shareNum',
      name: 'shareNum',
      component: () => import('@/views/pms/productDataManagement/shareNum'),
      meta: { title: '分享商品', icon: 'product-list' }
    }, {
      path: 'shopNum',
      name: 'shopNum',
      component: () => import('@/views/pms/productDataManagement/shopNum'),
      meta: { title: '铺货商品', icon: 'product-list' }
    }, {
      path: 'collectionNum',
      name: 'collectionNum',
      component: () => import('@/views/pms/productDataManagement/collectionNum'),
      meta: { title: '收藏商品', icon: 'product-list' }
    }]
  },
  // 商品模块
  {
    path: '/pro',
    component: Layout,
    redirect: '/pro/position',
    name: 'pro',
    meta: { title: '推广管理', icon: 'product' },
    children: [ {
        path: 'position',
        name: 'position',
        component: () => import('@/views/pro/position/index'),
        meta: { title: '我的商品推广', icon: 'product' }
      }, {
        path: 'mchtPosition',
        name: 'mchtPosition',
        component: () => import('@/views/pro/position/MchtPosition'),
        meta: { title: '商户商品推广列表', icon: 'product-list' },

      }, {
        path: 'addPosition',
        name: 'addPosition',
        component: () => import('@/views/pro/position/addPosition'),
        meta: { title: '新增广告推广', icon: 'product-list' },

      }, {
        path: 'changePosition',
        name: 'changePosition',
        component: () => import('@/views/pro/position/changePosition'),
        meta: { title: '更换广告推广', icon: 'product-list' },
        hidden: true
      }, {
        path: 'updatePosition',
        name: 'updatePosition',
        component: () => import('@/views/pro/position/updatePosition'),
        meta: { title: '修改广告推广', icon: 'product-list' },
        hidden: true
      }, {
      path: 'wposition',
      name: 'wposition',
      component: () => import('@/views/pro/position/payment/wposition'),
      meta: { title: '广告微信支付页面' },
      hidden: true
    }, {
      path: 'aliposition',
      name: 'aliposition',
      component: () => import('@/views/pro/position/payment/aliposition'),
      meta: { title: '广告支付宝支付页面' },
      hidden: true
    }
      ]
  },
  // 供货平台
  {
    path: '/sup',
    component: Layout,
    redirect: '/sup/supplyProduct',
    name: 'sup',
    meta: { title: '供货平台', icon: 'product' },
    children: [ {
      path: 'supplyProduct',
      name: 'supplyProduct',
      component: () => import('@/views/sup/supplyProduct/index'),
      meta: { title: '供货商品', icon: 'product-list' }
    },
      {
        path: 'addSupplyProduct',
        name: 'addSupplyProduct',
        component: () => import('@/views/sup/supplyProduct/addProduct'),
        meta: { title: '选择商品', icon: 'product-list' }
      },
      {
        path: 'addAttribute',
        name: 'addAttribute',
        component: () => import('@/views/sup/supplyProduct/AddAttribute'),
        meta: { title: '添加属性', icon: 'product-add' }
      }, {
        path: 'sendOrder',
        name: 'sendOrder',
        component: () => import('@/views/sup/sendOrder'),
        meta: { title: '打单发货', icon: 'order' },
      }, {
        path: 'supplyOrderDetail',
        name: 'supplyOrderDetail',
        component: () => import('@/views/sup/orderDetail'),
        meta: { title: '订单详情', icon: 'order-detail' },
      }, {
        path: 'refund',
        name: 'refund',
        component: () => import('@/views/sup/refund'),
        meta: { title: '售后订单', icon: 'product-list' }
      }, {
        path: 'refundDetail',
        name: 'refundDetail',
        component: () => import('@/views/sup/refundDetail'),
        meta: { title: '售后详情', icon: 'product-list' }
      }, {
        path: 'settleLog',
        name: 'settleLog',
        component: () => import('@/views/sup/settleLog'),
        meta: { title: '结算提现', icon: 'product-list' }
      }, {
        path: 'electron',
        name: 'electron',
        component: () => import('@/views/sup/electron'),
        meta: { title: '电子面单记录', icon: 'product-list' }
      }
    ]
  },
  // 订单模块
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: { title: '订单', icon: 'order' },
    children: [{
      path: 'order',
      name: 'order',
      component: () => import('@/views/oms/order/index'),
      meta: { title: '所有订单', icon: 'product-list' }
    }, {
      path: 'invoice',
      name: 'invoice',
      component: () => import('@/views/oms/bill/invoice'),
      meta: { title: '发货订单', icon: 'product-list' }
    }, {
      path: 'refund',
      name: 'refund',
      component: () => import('@/views/oms/bill/refund'),
      meta: { title: '退货订单', icon: 'product-list' }
    }, {
      path: 'writeOffRecord',
      name: 'writeOffRecord',
      component: () => import('@/views/oms/bill/writeOffRecord'),
      meta: { title: '核销记录', icon: 'product-list' }
    }, {
      path: 'orderDetail',
      name: 'orderDetail',
      component: () => import('@/views/oms/order/orderDetail'),
      meta: { title: '订单详情' },
      hidden: true
    }, {
      path: 'orderSetting',
      name: 'orderSetting',
      component: () => import('@/views/oms/order/setting'),
      meta: { title: '订单设置', icon: 'order-setting' },
      hidden: true
    }, {
      path: 'returnApply',
      name: 'returnApply',
      component: () => import('@/views/oms/apply/index'),
      meta: { title: '退货申请', icon: 'order-return' },
      hidden: true
    }, {
      path: 'returnReason',
      name: 'returnReason',
      component: () => import('@/views/oms/apply/reason'),
      meta: { title: '退货设置', icon: 'order-return-reason' },
      hidden: true
    }, {
      path: 'returnApplyDetail',
      name: 'returnApplyDetail',
      component: () => import('@/views/oms/apply/applyDetail'),
      meta: { title: '退货原因' },
      hidden: true
    }, {
      path: 'returnOrder',
      name: 'returnOrder',
      component: () => import('@/views/oms/apply/returnOrder'),
      meta: { title: '查看退货单' },
      hidden: true
    }, {
      path: 'invoiceDetail',
      name: 'invoiceDetail',
      component: () => import('@/views/oms/bill/invoiceDetail'),
      meta: { title: '发货单详情' },
      hidden: true
    }, {
      path: 'refundDetail',
      name: 'refundDetail',
      component: () => import('@/views/oms/bill/refundDetail'),
      meta: { title: '退货单详情' },
      hidden: true
    }, {
      path: 'operationReturn',
      name: 'operationReturn',
      component: () => import('@/views/oms/bill/operationReturn'),
      meta: { title: '退货退款操作' },
      hidden: true
    }, {
      path: 'refundReason',
      name: 'refundReason',
      component: () => import('@/views/oms/bill/refundReason'),
      meta: { title: '退货原因', icon: 'product-list' },
      hidden: true
    }, {
      path: 'settingReason',
      name: 'settingReason',
      component: () => import('@/views/oms/bill/settingReason'),
      meta: { title: '添加/编辑退换货原因' },
      hidden: true
    }, {
      path: 'magComplaint',
      name: 'magComplaint',
      component: () => import('@/views/oms/com/magComplaint'),
      meta: { title: '交易投诉', icon: 'product-list' },
      hidden: true
    }, {
      path: 'typeComplaint',
      name: 'typeComplaint',
      component: () => import('@/views/oms/com/typeComplaint'),
      meta: { title: '投诉类型', icon: 'product-list' },
      hidden: true
    }, {
      path: 'settingPrescription',
      name: 'settingPrescription',
      component: () => import('@/views/oms/com/settingPrescription'),
      meta: { title: '投诉时效', icon: 'product-list' },
      hidden: true
    }, {
      path: 'handlingComplaint',
      name: 'handlingComplaint',
      component: () => import('@/views/oms/com/handlingComplaint'),
      meta: { title: '投诉交易处理' },
      hidden: true
    }, {
      path: 'packageList',
      name: 'packageList',
      component: () => import('@/views/oms/package'),
      meta: { title: '包裹管理', icon: 'product-cate' }
    }, {
      path: 'complainManagement',
      name: 'complainManagement',
      component: () => import('@/views/oms/complainManagement/index'),
      meta: { title: '投诉管理', icon: 'product-list' },
    }, {
      path: 'complainDetail',
      name: 'complainDetail',
      component: () => import('@/views/oms/complainManagement/complainDetail'),
      meta: { title: '投诉申诉' },
      hidden: true
    }, {
      path: 'lookDetail',
      name: 'lookDetail',
      component: () => import('@/views/oms/complainManagement/lookDetail'),
      meta: { title: '投诉单查看' },
      hidden: true
    }]
  },
  // 电子面单模块
  {
    path: '/elec',
    component: Layout,
    redirect: '/elec/openElec',
    name: 'elec',
    meta: { title: '电子面单', icon: 'product' },
    children: [ {
      path: 'openElect',
      name: 'openElect',
      component: () => import('@/views/elec/openElect'),
      meta: { title: '开通电子面单', icon: 'order-setting' }
    }, {
      path: 'sendOrder',
      name: 'sendOrder',
      component: () => import('@/views/elec/sendOrder'),
      meta: { title: '打单发货', icon: 'order' },
    }
    ]
  },
  // 营销模块
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/campaign',
    name: 'sms',
    meta: { title: '营销', icon: 'sms' },
    children: [
      {
        path: 'campaign',
        name: 'campaign',
        component: () => import('@/views/sms/campaign'),
        meta: { title: '营销活动', icon: 'product-brand' }
      },
      {
        path: 'campaignDetail',
        name: 'campaignDetail',
        component: () => import('@/views/sms/campaign/detail'),
        meta: { title: '活动详情', icon: 'order' },
        hidden: true
      },
      {
        path: 'enrollList',
        name: 'enrollList',
        component: () => import('@/views/sms/campaign/list'),
        meta: { title: '活动报名', icon: 'order-return-reason' }
      },
      {
        path: 'enrollShop',
        name: 'enrollShop',
        component: () => import('@/views/sms/campaign/shop'),
        meta: { title: '报名商家', icon: 'order' },
        hidden: true
      },
      {
        path: 'goodsAudit',
        name: 'goodsAudit',
        component: () => import('@/views/sms/campaign/goods'),
        meta: { title: '商品审核', icon: 'order' },
        hidden: true
      },
      {
        path: 'enrollCampaignInfo',
        name: 'enrollCampaignInfo',
        component: () => import('@/views/sms/campaign/info'),
        meta: { title: '报名信息', icon: 'order' },
        hidden: true
      },
      {
        path: 'reduction',
        name: 'reduction',
        component: () => import('@/views/sms/reduction'),
        meta: { title: '满减管理', icon: 'sms-ad' }
      },
      {
        path: 'reductionDetail',
        name: 'reductionDetail',
        component: () => import('@/views/sms/reduction/ReductionDetail'),
        meta: { title: '满减详情', icon: 'sms-ad' },
        hidden: true
      },
      {
        path: 'editReduction',
        name: 'editReduction',
        component: () => import('@/views/sms/reduction/EditReduction'),
        meta: { title: '编辑满减', icon: 'sms-ad' },
        hidden: true
      },
      {
        path: 'discount',
        name: 'discount',
        component: () => import('@/views/sms/discount'),
        meta: { title: '限时折扣', icon: 'sms-subject' }
      },
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash'),
        meta: { title: '秒杀活动', icon: 'sms-flash' }
      },
      {
        path: 'editFlash',
        name: 'editFlash',
        component: () => import('@/views/sms/flash/EditFlash'),
        meta: { title: '编辑秒杀', icon: 'sms-flash' },
        hidden: true
      },
      {
        path: 'flashDetail',
        name: 'flashDetail',
        component: () => import('@/views/sms/flash/FlashDetail'),
        meta: { title: '秒杀详情', icon: 'sms-flash' },
        hidden: true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon'),
        meta: { title: '优惠券管理', icon: 'sms-coupon' }
      },
      {
        path: 'couponDetail',
        name: 'couponDetail',
        component: () => import('@/views/sms/coupon/CouponDetail'),
        meta: { title: '优惠券详情', icon: 'sms-coupon' },
        hidden: true
      },
      {
        path: 'editCoupon',
        name: 'editCoupon',
        component: () => import('@/views/sms/coupon/EditCoupon'),
        meta: { title: '编辑优惠券', icon: 'sms-coupon' },
        hidden: true
      },
      {
        path: 'assemble',
        name: 'assemble',
        component: () => import('@/views/sms/assemble'),
        meta: { title: '拼货管理', icon: 'sms-coupon' }
      },
      {
        path: 'addAssemble',
        name: 'addAssemble',
        component: () => import('@/views/sms/assemble/AddAssemble'),
        meta: { title: '添加拼货商品', icon: 'sms-coupon' },
        hidden: true
      },
      {
        path: 'editAssemble',
        name: 'editAssemble',
        component: () => import('@/views/sms/assemble/EditAssemble'),
        meta: { title: '编辑拼货商品', icon: 'sms-coupon' },
        hidden: true
      },
      {
        path: 'assembleDetail',
        name: 'assembleDetail',
        component: () => import('@/views/sms/assemble/assembleDetail'),
        meta: { title: '拼货商品详情', icon: 'sms-coupon' },
        hidden: true
      }
    ],
    hidden: true
  },
  // 类目模块
  {
    path: '/ppc',
    component: Layout,
    redirect: '/ppc/classifyList',
    name: 'ppc',
    meta: { title: '类目', icon: 'table' },
    children: [{
      path: 'tagGroupList',
      name: 'tagGroupList',
      component: () => import('@/views/ppc/TagGroupList'),
      meta: { title: '平台标签组', icon: 'marker' },
      hidden: true
    }, {
      path: 'shopTagGroupList',
      name: 'shopTagGroupList',
      component: () => import('@/views/ppc/ShopTagGroupList'),
      meta: { title: '商家标签组', icon: 'marker' }
    }, {
      path: 'attributeClassifyList',
      name: 'attributeClassifyList',
      component: () => import('@/views/ppc/AttributeClassifyList'),
      meta: { title: '属性分类', icon: 'product-list' },
      hidden: true
    }, {
      path: 'attributeTypeList',
      name: 'attributeTypeList',
      component: () => import('@/views/ppc/AttributeTypeList'),
      meta: { title: '属性类型', icon: 'product-list' },
      hidden: true
    }, {
      path: 'attributeGroupList',
      name: 'attributeGroupList',
      component: () => import('@/views/ppc/AttributeGroupList'),
      meta: { title: '属性分组', icon: 'product-list' },
      hidden: true
    }, {
      path: 'attributeList',
      name: 'attributeList',
      component: () => import('@/views/ppc/AttributeList'),
      meta: { title: '属性管理', icon: 'product-list' },
      hidden: true
    }, {
      path: 'classifyList',
      name: 'classifyList',
      component: () => import('@/views/ppc/ClassifyList'),
      meta: { title: '分类设定', icon: 'product-cate' }
    }, {
      path: 'classifyAttributeList',
      name: 'classifyAttributeList',
      component: () => import('@/views/ppc/ClassifyAttributeList'),
      meta: { title: '分类属性', icon: 'product-cate' },
      hidden: true
    }, {
      path: 'ownClassifyList',
      name: 'ownClassifyList',
      component: () => import('@/views/ppc/OwnClassifyList'),
      meta: { title: '自有分类', icon: 'tree' }
    }, {
      path: 'brand',
      name: 'brand',
      component: () => import('@/views/pms/brand/index'),
      meta: { title: '品牌管理', icon: 'product-brand' }
    }, {
      path: 'addBrand',
      name: 'addBrand',
      component: () => import('@/views/pms/brand/add'),
      meta: { title: '添加品牌' },
      hidden: true
    }, {
      path: 'updateBrand',
      name: 'updateBrand',
      component: () => import('@/views/pms/brand/update'),
      meta: { title: '编辑品牌' },
      hidden: true
    }, {
      path: 'brandView',
      name: 'brandView',
      component: () => import('@/views/pms/brand/components/BrandView'),
      meta: { title: '查看品牌' },
      hidden: true
    }]
  },
  // 财务模块
  {
    path: '/fms',
    component: Layout,
    redirect: '/fms/capitalSubsidiary',
    name: 'fms',
    meta: { title: '财务', icon: 'total-today' },
    children: [{
      path: 'financial',
      name: 'financial',
      component: () => import('@/views/fms/Financial/index'),
      meta: { title: '财务总览', icon: 'marker' },
      hidden: false
    }, {
      path: 'capitalSubsidiary',
      name: 'capitalSubsidiary',
      component: () => import('@/views/fms/capitalSubsidiary/index'),
      meta: { title: '资金明细', icon: 'marker' },
      hidden: false
    }, {
      path: 'waitSettle',
      name: 'waitSettle',
      component: () => import('@/views/fms/waitSettle/index'),
      meta: { title: '待结算订单', icon: 'marker' },
      hidden: false
    }, {
      path: 'beenSettle',
      name: 'beenSettle',
      component: () => import('@/views/fms/beenSettle/index'),
      meta: { title: '已结算订单', icon: 'marker' },
      hidden: false
    }, {
      path: 'withDraw',
      name: 'withDraw',
      component: () => import('@/views/fms/withDraw/index'),
      meta: { title: '提现明细', icon: 'marker' },
      hidden: false
    }, {
      path: 'cashMoney',
      name: 'cashMoney',
      component: () => import('@/views/fms/cashMoney/index'),
      meta: { title: '保证金管理', icon: 'marker' },
      hidden: false
    }, {
      path: 'refundInfo',
      name: 'refundInfo',
      component: () => import('@/views/fms/cashMoney/refundInfo'),
      meta: { title: '退货退保证金', icon: 'marker' },
      hidden: true
    }, {
      path: 'beenSettleDetail',
      name: 'beenSettleDetail',
      component: () => import('@/views/fms/beenSettle/beenSettleDetail'),
      meta: { title: '结算详情' },
      hidden: true
    }, {
      path: 'payment',
      name: 'payment',
      component: () => import('@/views/fms/cashMoney/payment'),
      meta: { title: '保证金缴纳页面' },
      hidden: true
    }]
  },
  // 报表模块
  {
    path: '/rfm',
    component: Layout,
    redirect: '/rfm/orderStatistics',
    name: 'rfm',
    meta: { title: '报表', icon: 'total-today' },
    children: [{
      path: 'goodsstatistics',
      name: 'goodsstatistics',
      component: () => import('@/views/rfm/goodsstatistics'),
      meta: { title: '商品统计', icon: 'order' },
      hidden: false
    }, {
      path: 'orderStatistics',
      name: 'orderStatistics',
      component: () => import('@/views/rfm/orderStatistics'),
      meta: { title: '订单统计', icon: 'marker' },
      hidden: false
    }, {
      path: 'salesStatistics',
      name: 'salesStatistics',
      component: () => import('@/views/rfm/salesStatistics/index'),
      meta: { title: '销售统计', icon: 'ums-menu' },
      hidden: false
    }, {
      path: 'salesDetail',
      name: 'salesDetail',
      component: () => import('@/views/rfm/salesStatistics/salesDetail'),
      meta: { title: '销售明细' },
      hidden: true
    }, {
      path: 'CategoryStatistics',
      name: 'CategoryStatistics',
      component: () => import('@/views/rfm/CategoryStatistics/index'),
      meta: { title: '类目商品统计', icon: 'ums-menu' },
      hidden: false
    }, {
      path: 'categoryAnalysis',
      name: 'categoryAnalysis',
      component: () => import('@/views/rfm/CategoryStatistics/categoryAnalysis'),
      meta: { title: '类目分析', icon: 'ums-menu' },
      hidden: false
    }, {
      path: 'categorySaleStatistical',
      name: 'categorySaleStatistical',
      component: () => import('@/views/rfm/CategoryStatistics/categorySaleStatistical'),
      meta: { title: '类目销售统计', icon: 'ums-menu' },
      hidden: false
    }, {
      path: 'goodsSaleSaleStatistical',
      name: 'goodsSaleSaleStatistical',
      component: () => import('@/views/rfm/CategoryStatistics/goodsSaleSaleStatistical'),
      meta: { title: '商品销售统计', icon: 'ums-menu' },
      hidden: true
    }, {
      path: 'accessStatistics',
      name: 'accessStatistics',
      component: () => import('@/views/rfm/accessStatistics'),
      meta: { title: '用户访问统计', icon: 'ums-menu' },
      hidden: false
    }]
  },
  // 店铺模块
  {
    path: '/ssm',
    component: Layout,
    redirect: '/ssm/addSupplier',
    name: 'ssm',
    hidden: false,
    meta: { title: '店铺', icon: 'sms-subject' },
    children: [{
      path: 'addSupplier',
      name: 'addSupplier',
      component: () => import('@/views/ssm/AddSupplier'),
      meta: { title: '入驻申请', icon: 'product-add' },
      hidden: false
    }, {
      path: 'selectType',
      name: 'selectType',
      component: () => import('@/views/ssm/selectType'),
      meta: { title: '店铺类型选择', icon: 'product-add' },
      hidden: false
    },
    {
      path: 'viewSupplier',
      name: 'viewSupplier',
      component: () => import('@/views/ssm/ViewSupplier'),
      meta: { title: '入驻查看', icon: 'product-add' },
      hidden: false
    },
      {
        path: 'supplierPayAuth',
        name: 'supplierPayAuth',
        component: () => import('@/views/ssm/SupplierPayAuth'),
        meta: { title: '申请支付', icon: 'product-add' },
        hidden: false
      },
    {
      path: 'shopJoinSetting',
      name: 'shopJoinSetting',
      component: () => import('@/views/ssm/ShopJoinSetting'),
      meta: { title: '入驻设定', icon: 'order-setting' },
      hidden: true
    }, {
      path: 'supplierSettledList',
      name: 'supplierSettledList',
      component: () => import('@/views/ssm/SupplierSettledList'),
      meta: { title: '供应商列表', icon: 'product-list' },
      hidden: true
    }, {
      path: 'supplierShopList',
      name: 'supplierShopList',
      component: () => import('@/views/ssm/SupplierShopList'),
      meta: { title: '商铺列表', icon: 'order' },
      hidden: true
    }, {
        path: 'productLitting',
        name: 'productLitting',
        component: () => import('@/views/ssm/productLitting'),
        meta: { title: '商品数管理', icon: 'order' },
        hidden: true
      }, {
      path: 'shopLevelList',
      name: 'shopLevelList',
      component: () => import('@/views/ssm/ShopLevelList'),
      meta: { title: '商铺等级', icon: 'product-cate' },
      hidden: true
    }, {
      path: 'shop',
      name: 'shop',
      component: () => import('@/views/ssm/shop'),
      meta: { title: '店铺', icon: 'product-cate' },
      hidden: true
    }, {
      path: 'supplier',
      name: 'supplier',
      component: () => import('@/views/ssm/Supplier'),
      meta: { title: '供应商', icon: 'product-cate' },
      hidden: true
    },
    {
      path: 'shippingAddress',
      name: 'shippingAddress',
      component: () => import('@/views/ssm/shippingAddress'),
      meta: { title: '发货地址管理', icon: 'product-add' },
      hidden: false
    },
    {
      path: 'returnsAddress',
      name: 'returnsAddress',
      component: () => import('@/views/ssm/returnsAddress'),
      meta: { title: '退货地址管理', icon: 'product-add' },
      hidden: false
    },
    {
      path: 'shopIntroduced',
      name: 'shopIntroduced',
      component: () => import('@/views/ssm/shopIntroduced'),
      meta: { title: '店铺介绍', icon: 'product-cate' },
      hidden: false
    },
    {
      path: 'homepageBanner',
      name: 'homepageBanner',
      component: () => import('@/views/ssm/homepageBanner'),
      meta: { title: '首页横幅', icon: 'product-cate' },
      hidden: false
    },
    {
      path: 'homepageContent',
      name: 'homepageContent',
      component: () => import('@/views/ssm/homepageContent'),
      meta: { title: '首页内容', icon: 'product-cate' },
      hidden: false
    },
    {
      path: 'customPage',
      name: 'customPage',
      component: () => import('@/views/ssm/customPage'),
      meta: { title: '自定义栏目', icon: 'product-cate' },
      hidden: false
    },
    {
      path: 'searchSettings',
      name: 'searchSettings',
      component: () => import('@/views/ssm/searchSettings'),
      meta: { title: 'SEO设置', icon: 'product-cate' },
      hidden: false
    },
    {
      path: 'backgroundSet',
      name: 'backgroundSet',
      component: () => import('@/views/ssm/backgroundSet'),
      meta: { title: '背景设置', icon: 'product-cate' },
      hidden: false
    },
    {
      path: 'printSetup',
      name: 'printSetup',
      component: () => import('@/views/ssm/printSetup'),
      meta: { title: '打印设置', icon: 'product-cate' },
      hidden: false
    },
    {
      path: 'cashManagement',
      name: 'cashManagement',
      component: () => import('@/views/ssm/cashManagement'),
      meta: { title: '提现账户', icon: 'product-cate' },
      hidden: false
    },
    {
      path: 'help',
      name: 'help',
      component: () => import('@/views/ssm/help'),
      meta: { title: '帮助', icon: 'product-cate' },
      hidden: false
    },
      {
        path: 'erp',
        name: 'erp',
        component: () => import('@/views/ssm/ViewErp'),
        meta: { title: '聚水潭授权', icon: 'product-cate' },
        hidden: false
      },
      {
        path: 'serviceErp',
        name: 'serviceErp',
        component: () => import('@/views/ssm/ViewServiceErp'),
        meta: { title: '聚水潭服务授权', icon: 'product-cate' },
        hidden: false
      },
    {
        path: 'messageCenter',
        name: 'messageCenter',
        component: () => import('@/views/ssm/messageCenter/index'),
        meta: { title: '网站公告', icon: 'product-cate' },
        hidden: false
    }, {
        path: 'wpayment',
        name: 'wpayment',
        component: () => import('@/views/ssm/payment/wpayment'),
        meta: { title: '保证金缴纳页面' },
        hidden: true
      }, {
        path: 'alipayment',
        name: 'alipayment',
        component: () => import('@/views/ssm/payment/alipayment'),
        meta: { title: '支付宝保证金缴纳页面' },
        hidden: true
      }
    ]
  },
  // 运费模块
  {
    path: '/cfc',
    component: Layout,
    redirect: '/cfc/freightManage',
    name: 'cfc',
    meta: { title: '运费', icon: 'total-yesterday' },
    children: [{
      path: 'deliveryWay',
      name: 'deliveryWay',
      component: () => import('@/views/cfc/deliveryWay/index'),
      meta: { title: '配送方式', icon: 'product-list' },
    },
    {
      path: 'freightManage',
      name: 'freightManage',
      component: () => import('@/views/cfc/freightManage/index'),
      meta: { title: '运费管理', icon: 'product-list' },
    }, {
      path: 'addTemplate',
      name: 'addTemplate',
      component: () => import('@/views/cfc/freightManage/addTemplate'),
      meta: { title: '添加新模板', icon: 'product-list' },
      hidden: true
    }, {
      path: 'pickupTime',
      name: 'pickupTime',
      component: () => import('@/views/cfc/PickupTime'),
      meta: { title: '自提时间段', icon: 'product-list' }
    }, {
      path: 'ExpressDeploy',
      name: 'ExpressDeploy',
      component: () => import('@/views/cfc/ExpressDeploy'),
      meta: { title: '快递鸟配置', icon: 'product-list' },
      hidden: true
    }, {
      path: 'ExpressType',
      name: 'ExpressType',
      component: () => import('@/views/cfc/ExpressType'),
      meta: { title: '快递100配置', icon: 'product-list' },
      hidden: true
    }]
  },
  // 权限模块
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: { title: '权限', icon: 'ums' },
    children: [{
      path: 'admin',
      name: 'admin',
      component: () => import('@/views/ums/admin/index'),
      meta: { title: '用户列表', icon: 'ums-admin' }
    }, {
      path: 'role',
      name: 'role',
      component: () => import('@/views/ums/role/index'),
      meta: { title: '角色列表', icon: 'ums-role' }
    }, {
      path: 'allocMenu',
      name: 'allocMenu',
      component: () => import('@/views/ums/role/allocMenu'),
      meta: { title: '分配菜单' },
      hidden: true
    }, {
      path: 'allocResource',
      name: 'allocResource',
      component: () => import('@/views/ums/role/allocResource'),
      meta: { title: '分配资源' },
      hidden: true
    },
    //   {
    //   path: 'menu',
    //   name: 'menu',
    //   component: () => import('@/views/ums/menu/index'),
    //   meta: { title: '菜单列表', icon: 'ums-menu' }
    // },
    {
      path: 'addMenu',
      name: 'addMenu',
      component: () => import('@/views/ums/menu/add'),
      meta: { title: '添加菜单' },
      hidden: true
    }, {
      path: 'updateMenu',
      name: 'updateMenu',
      component: () => import('@/views/ums/menu/update'),
      meta: { title: '修改菜单' },
      hidden: true
    }, {
      path: 'resource',
      name: 'resource',
      component: () => import('@/views/ums/resource/index'),
      meta: { title: '资源列表', icon: 'ums-resource' }
    }, {
      path: 'resourceCategory',
      name: 'resourceCategory',
      component: () => import('@/views/ums/resource/categoryList'),
      meta: { title: '资源分类' },
      hidden: true
    }, {
      path: 'log',
      name: 'log',
      component: () => import('@/views/ums/log/index'),
      meta: { title: '操作日志', icon: 'ums-role' },
      hidden: false
    }, {
      path: 'department',
      name: 'department',
      component: () => import('@/views/ums/department/index'),
      meta: { title: '部门管理', icon: 'ums-menu' },
      hidden: false
    }]
  },
  // 分销模块
  {
    path: '/drm',
    component: Layout,
    redirect: '/drm/distributorManagement',
    name: 'drm',
    meta: { title: '分销', icon: 'order' },
    children: [
      {
        path: 'distributorManagement',
        name: 'distributorManagement',
        component: () => import('@/views/drm/distributorManagement/index'),
        meta: { title: '分销商管理', icon: 'product-list' },
      }, {
        path: 'bidManagement',
        name: 'bidManagement',
        component: () => import('@/views/drm/bidManagement/index'),
        meta: { title: '报价管理', icon: 'product-list' },
      }, {
        path: 'cooperationAllocation',
        name: 'cooperationAllocation',
        component: () => import('@/views/drm/cooperationAllocation'),
        meta: { title: '合作配置', icon: 'product-list' },
      }
    ]
  },
  // 服务商
  {
    path: '/isp',
    component: Layout,
    redirect: '/isp/addFacilitator',
    name: 'isp',
    hidden: false,
    meta: { title: '服务商', icon: 'sms-subject' },
    children: [
      // {
      //   path: 'ispHome',
      //   name: 'ispHome',
      //   component: () => import('@/views/isp/ispHome'),
      //   meta: { title: '首页', icon: 'product-add' },
      //   hidden: false
      // },
      {
        path: 'addFacilitator',
        name: 'addFacilitator',
        component: () => import('@/views/isp/AddFacilitator'),
        meta: { title: '入驻申请', icon: 'product-add' },
        hidden: false
      },
      {
        path: 'messageCenter',
        name: 'messageCenter',
        component: () => import('@/views/isp/messageCenter'),
        meta: { title: '消息中心', icon: 'product-add' },
        hidden: false
      },
      {
        path: 'service',
        name: 'service',
        component: () => import('@/views/isp/service/index'),
        meta: { title: '在售服务', icon: 'product-add' },
        hidden: false
      }, {
        path: 'auditService',
        name: 'auditService',
        component: () => import('@/views/isp/service/auditService'),
        meta: { title: '待审核服务', icon: 'product-add' },
        hidden: false
      }, {
        path: 'soldOutService',
        name: 'soldOutService',
        component: () => import('@/views/isp/service/SoldOutService'),
        meta: { title: '下架服务', icon: 'product-add' },
        hidden: false
      }, {
        path: 'submitService',
        name: 'submitService',
        component: () => import('@/views/isp/service/submitService'),
        meta: { title: '待提交服务', icon: 'product-add' },
        hidden: false
      }, {
        path: 'refuseService',
        name: 'refuseService',
        component: () => import('@/views/isp/service/refuseService'),
        meta: { title: '被拒服务', icon: 'product-add' },
        hidden: false
      }, {
        path: 'addService',
        name: 'addService',
        component: () => import('@/views/isp/service/addService'),
        meta: { title: '添加服务', icon: 'product-add' },
        hidden: false
      },
      {
        path: 'serviceDetail',
        name: 'serviceDetail',
        component: () => import('@/views/isp/service/serviceDetail'),
        meta: { title: '服务详情', icon: 'product-add' },
        hidden: true
      }
    ]
  },
  {
    path: '/sys',
    component: Layout,
    redirect: '/sys/personalInfo',
    name: 'sys',
    hidden: false,
    meta: { title: '个人信息', icon: 'ums-role' },
    children: [
      {
        path: 'personalInfo',
        name: 'personalInfo',
        component: () => import('@/views/sys/personal'),
        meta: { title: '编辑资料', icon: 'ums-admin' },
        hidden: false
      },
      {
        path: 'changePhone',
        name: 'changePhone',
        component: () => import('@/views/sys/ChangePhone'),
        meta: { title: '更换手机', icon: 'sms-subject' },
        hidden: false
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js